module.exports = __webpack_public_path__ + "img/lcb.1c20a22c.png";